/**
 * Shared sizing + typography for the inline field controls in an
 * `AgentEnvVarRow`: the key `Input`, the plaintext value `Input`, and the
 * secret picker trigger `Button`. The `w-0 min-w-[7rem] flex-1` triplet is
 * load-bearing — it lets every control shrink with the row inside the narrow
 * config-chip popover (`min-w-[12rem] max-w-[20rem]`) while `min-w-[7rem]`
 * keeps each one usable when the popover is at its floor.
 *
 * Keeping this in one place is the fix's root: the three siblings must size
 * identically or a shrinking row spills its trailing controls. The bug this
 * guards was the picker trigger drifting to a bare `flex-1` (no `w-0`), so it
 * kept its content width and pushed the row's remove button past the
 * popover's right edge.
 */
export const ENV_VAR_ROW_FIELD_CLASS = 'h-7 w-0 min-w-[7rem] flex-1 font-mono text-xs';
